import {
    Component,
    OnInit,
    AfterViewInit
} from '@angular/core';
import {
    Constants
} from '../Services/Constants';
import {
    HTTPService
} from '../Services/http.service';
import {
    Observable
} from 'rxjs/Observable';
import {
    filter
} from '../App/search.pipe';
import {
    DatePipe
} from "@angular/common";
import {
    MySharedService
} from '../App/shared.service';
import {
    ActivatedRoute,
    Router
} from '@angular/router';

@Component({
    templateUrl: './AppViews/VendorView/vendorview.html',
    styleUrls: ['./AppViews/VendorView/vendorview.css']
})

export class vendorViewComponent implements OnInit, AfterViewInit {

    constants: Constants;
    userDetail: any;
    active = true;
    filter: any = {
        'CustomerId': 0,
        'FromDate': null,
        'ToDate': null,
        'StatusId': 0,
        'TaskId': 0
    };
    editLocationTaskData: any = {
        CompletedOn: "",
        CustomerAddress: "",
        CustomerCityId: "",
        CustomerCityName: "",
        CustomerContactNumber: "",
        CustomerContactPerson: "",
        CustomerDesignation: "",
        CustomerEmail: "",
        CustomerId: "",
        CustomerName: "",
        CustomerPincode: "",
        CustomerStateId: "",
        CustomerStateName: "",
        EstimatedHours: "",
        ImageUploadFile: "",
        InstallationRemark: "",
        InstallationReport: "",
        LocationCode: "",
        LocationId: "",
        LocationName: "",
        PersonContactedName: "",
        PlannedEndDate: "",
        PlannedStartDate: "",
        ProjectId: "",
        ProjectName: "",
        ScopeOfWork: "",
        Status: "",
        StatusNo: "",
        SwanContact: "",
        TaskDescription: "",
        TaskId: "",
        TaskLocationId: "",
        TaskOwner: "",
        TaskOwnerId: "",
        TaskTitle: "",
        TaskGroupId: "",
        TaskTypeName: "",
        VendorId: "",
        TLPlannedStartDate: "",
        TLPlannedEndDate: "",
        Fee: 0,
        LastComment: "",
    };
    addTaskCommentData: any = {
        TaskLogId: 0,
        TaskLocationId: 0,
        StatusId: 0,
        Comments: "",
        TaskDate: "",
        CreatedBy: "",
        AssignedTo: ""
    };
    TaskType: any;
    TaskDescription: any;
    ScopeOfWork: any;
    EstimatedHours: any;
    getCustomerLocationUrl: any;
    getTaskLocationUrl: any;
    getMultiLocationTaskUrl: any;
    public showLoader = false;
    taskListItems: any = [];
    taskTypeItems: any = [];
    userData: any = [];
    customerLocationListItems: any = [];
    isEditLocationDataFormSubmitted: boolean = false;
    taskStatusItems: any = [];
    multiLocationTaskList: any = [];
    taskCommentsList: any = [];
    isAddCommentsFormSubmitted: boolean;
    InstallationReport: any;
    ImageUploadFile: any;
    taskLocationList: any = [];
    documentRoute: any;
    fileList: any;
    reportFile: any;
    isValidFromTo: boolean = true;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe, private route: ActivatedRoute, private _route: Router) {

        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter.TeamId = "";
        this.getTaskLocationUrl = "LocationTask/GetTaskListForVendorView";
        this.getMultiLocationTaskUrl = "LocationTask/GetTaskForVendorDropdown";
        this.getCustomerLocationUrl = "CustomerLocation/GetCustomerLocation";

    }

    ngOnInit() {
        this.BindDropdownData();
        this.GetMultiTaskLocationData();
        this.GetLocationTaskList();
        console.log(this.userDetail);
    }

    ngAfterViewInit() {
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

    }


    BindDropdownData() {
        this.showLoader = true;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        //if(this.filter.TeamId==""){
        TeamId = 0

        //}
        // else{
        //     TeamId = this.filter.TeamId;
        // }
        this._httpService.ajaxPost('Users/GetUsersTeam', {
            "IsActive": this.constants.enumUserStatus["Active"],
            "Role": null,
            "Site": null,
            "Team": this.userDetail.TeamID,
            "UserId": UserId
        }).subscribe(
            data => {
                this.userData = data["Users"];
            },
            err => {
                this.showLoader = false;
                console.log("BindFilters Failed");
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = true;
                this._httpService.ajaxPost('Common/GetParameter', {
                    "ParameterTypeId": this.constants.enumParamterTypeName["TaskStatusType"]
                }).subscribe(
                    data => {
                        this.taskStatusItems = data["Parameter"];
                        this.taskStatusItems.sort(function (a, b) {
                            if (a.ParameterDescription.toLowerCase() < b.ParameterDescription.toLowerCase()) return -1;
                            if (a.ParameterDescription.toLowerCase() > b.ParameterDescription.toLowerCase()) return 1;
                            return 0;
                        })
                        this.taskStatusItems = this.taskStatusItems.filter((taskStatus) => (taskStatus.Value == this.constants.taskStatus["Assigned"] || taskStatus.Value == this.constants.taskStatus["Completed"]));
                    },
                    err => {
                        this.showLoader = false;
                        console.log("GetParameter Failed with status: " + err.status);
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                        this.showLoader = false;

                    }
                );
            }
        );
    }

    GetMultiTaskLocationData() {
        var UserId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }

        this.showLoader = true;
        this._httpService.ajaxPost(this.getMultiLocationTaskUrl, {
            "VendorId": this.userDetail.VendorId

        }).subscribe(
            data => {
                this.multiLocationTaskList = data["TaskList"];

            },
            err => {
                this.showLoader = false;
                console.log("GetMultiLocationTaskList Failed with status: " + err.status);
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
                console.log(this.multiLocationTaskList);
            }
        );
    }

    GetLocationTaskList() {
        this.showLoader = true;
        console.log(this.filter);
        this._httpService.ajaxPost(this.getTaskLocationUrl, {
            "TaskId": 0, //this.filter.TaskId,
            "CustomerId": 0,
            "ProjectId": 0,
            "VendorId": this.userDetail.VendorId,
            "FromDate": null,
            "ToDate": null,
            "StatusId": this.filter.StatusId
        }).subscribe(
            data => {
                this.taskLocationList = data["LocationTaskList"];
                this.documentRoute = data["FilePath"];

            },
            err => {
                this.showLoader = false;
                console.log("GetLocationTaskData Failed with status: " + err.status);
            },
            () => {
                this.showLoader = false;
                console.log("TaskLocationList: ");
                console.log(this.taskLocationList);
                console.log(this.documentRoute);
            }
        );
    }

    ShowAddComments(item: any) {
        this.editLocationTaskData.TaskTitle = item.TaskTitle;
        this.editLocationTaskData.VendorName = item.VendorName;
        this.editLocationTaskData.LocationName = item.LocationName;
        this.AddCommentsFormLoad();
        this.filter.TaskLocationId = item.TaskLocationId;
        this.GetTaskLocationComments(item.TaskLocationId);
    }

    public AddCommentsFormLoad() {
        $('#resetaddTaskCommentForm').trigger('click');
    }

    GetTaskLocationComments(TaskLocationId: any) {
        this.showLoader = true;
        this._httpService.ajaxPost('LocationTask/GetTaskCommentList', {
            "TaskLocationId": TaskLocationId
        }).subscribe(
            data => {
                this.taskCommentsList = data["CommentList"];
            },
            err => {
                this.showLoader = false;
                console.log("GetTaskLocationComments Failed");
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
                // console.log("Comments:");
                // console.log(this.taskCommentsList);
            }
        )
    }

    addUpdateTaskComments(objItem: any) {
        let TaskLocationId = objItem.TaskLocationId;
        this.showLoader = true;
        this._httpService.ajaxPost('LocationTask/AddUpdateTaskComment', objItem)
            .subscribe(
                data => {
                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        msg[0] = msg[0].toLowerCase();
                        this._sharedService.ShowMessage(data["Status"].Message);
                    } else {
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                    if (msg[0] == "success") {
                        $('#showAddComments').modal('hide');
                        // this.filter.TaskId = 0;
                        this.GetTaskLocationComments(TaskLocationId);
                        this.GetLocationTaskList();
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    public ResetAddComments(form: any) {
        form.reset();
        form.resetForm();

        setTimeout(() => {
            this.addTaskCommentData.Comments = "";
        },0)

        this.isAddCommentsFormSubmitted = false;
    }

    AddTaskComment(form: any) {
        this.isAddCommentsFormSubmitted = true;
        var dateNow = moment(new Date()).format('DD/MM/YYYY');
        if (form.form.valid) {
            let objItem: any = {};
            objItem.TaskLogId = this.addTaskCommentData.TaskLogId;
            objItem.TaskLocationId = this.filter.TaskLocationId;
            objItem.StatusId = this.addTaskCommentData.StatusId;
            objItem.Comments = this.addTaskCommentData.Comments;
            objItem.TaskDate = dateNow.toString();
            objItem.CreatedBy = this.userDetail.SiteUserId;
            objItem.AssignedTo = this.userDetail.SiteUserId;
            // console.log(objItem);
            this.addUpdateTaskComments(objItem);
            this.filter.TaskLocationId = 0;


        }
    }

    public CancelShowComments() {
        $('#showAddComments').modal('hide');
    }

    ViewLocationTask(item) {
        // let objItem: any = {};
        // objItem = JSON.parse(JSON.stringify(this.multiLocationTaskList.filter((task) => task.TaskId == item.TaskId)[0]));
        // this.filter.TaskId = item.TaskId;
        this.editLocationTaskData.TaskType = item.TaskTypeName;
        this.editLocationTaskData.TaskDescription = item.TaskDescription;
        this.editLocationTaskData.ScopeOfWork = item.ScopeOfWork;
        this.editLocationTaskData.EstimatedHours = item.EstimatedHours;
        this.editLocationTaskData.LocationCode = item.LocationCode;
        this.editLocationTaskData.LocationName = item.LocationName;
        this.editLocationTaskData.TLPlannedEndDate = item.TLPlannedEndDate;
        this.editLocationTaskData.TLPlannedStartDate = item.TLPlannedStartDate;
        this.editLocationTaskData.ProjectName = item.ProjectName;
        this.editLocationTaskData.TaskId = item.TaskId;
        this.editLocationTaskData.TaskTitle = item.TaskTitle;
        this.editLocationTaskData.VendorName = item.VendorName;
        this.editLocationTaskData.CustomerName = item.CustomerName;
        this.editLocationTaskData.CustomerContactPerson = item.CustomerContactPerson;
        this.editLocationTaskData.CustomerDesignation = item.CustomerDesignation;
        this.editLocationTaskData.CustomerContactNumber = item.CustomerContactNumber;
        this.editLocationTaskData.CustomerEmail = item.CustomerEmail;
        this.editLocationTaskData.CustomerAddress = item.CustomerAddress;
        this.editLocationTaskData.CustomerCityName = item.CustomerCityName;
        this.editLocationTaskData.CustomerPincode = item.CustomerPincode;
        this.editLocationTaskData.CustomerStateName = item.CustomerStateName;
        this.editLocationTaskData.SwanContact = item.SwanContact;
    }

    CancelViewLocationTask() {
        $('#viewLocationTask').modal('hide');
    }

    public ResetChangeDateLocationTaskForm(form: any) {
        // form.reset();
        // form.resetForm();
        this.isEditLocationDataFormSubmitted = false;
    }

    ChangeDateLocationTaskFormLoad() {
        $('#resetChangeDataLocationTaskForm').trigger('click');

    }

    ChangeDateLocationTask(item) {
        this.ChangeDateLocationTaskFormLoad();
        // this.filter.TaskId = item.TaskId;
        if (item.TaskId != null) this.editLocationTaskData.TaskId = item.TaskId;
        else this.editLocationTaskData.TaskId = "";
        if (item.Comment != null) this.editLocationTaskData.Comment = item.Comment;
        else this.editLocationTaskData.Comment = "";
        if (item.CompletedOn != null) this.editLocationTaskData.CompletedOn = item.CompletedOn;
        else this.editLocationTaskData.CompletedOn = "";
        if (item.CustomerPersonName != null) this.editLocationTaskData.CustomerPersonName = item.CustomerPersonName;
        else this.editLocationTaskData.CustomerPersonName = "";
        if (item.Fee != null) this.editLocationTaskData.Fee = item.Fee;
        else this.editLocationTaskData.Fee = 0;
        if (item.ImageUploadFile != null) this.editLocationTaskData.ImageUploadFile = item.ImageUploadFile;
        else this.editLocationTaskData.ImageUploadFile = "";
        if (item.InstallationRemark != null) this.editLocationTaskData.InstallationRemark = item.InstallationRemark;
        else this.editLocationTaskData.InstallationRemark = "";
        if (item.InstallationReport != null) this.editLocationTaskData.InstallationReport = item.InstallationReport;
        else this.editLocationTaskData.InstallationReport = "";
        if (item.Instruction != null) this.editLocationTaskData.Instruction = item.Instruction;
        else this.editLocationTaskData.Instruction = "";
        if (item.LocationCode != null) this.editLocationTaskData.LocationCode = item.LocationCode;
        else this.editLocationTaskData.LocationCode = "";
        if (item.LocationId != null) this.editLocationTaskData.LocationId = item.LocationId;
        else this.editLocationTaskData.LocationId = "";
        if (item.LocationName != null) this.editLocationTaskData.LocationName = item.LocationName;
        else this.editLocationTaskData.LocationName = "";
        if (item.TLPlannedEndDate != null) this.editLocationTaskData.TLPlannedEndDate = item.TLPlannedEndDate;
        else this.editLocationTaskData.TLPlannedEndDate = "";
        if (item.TLPlannedStartDate != null) this.editLocationTaskData.TLPlannedStartDate = item.TLPlannedStartDate;
        else this.editLocationTaskData.TLPlannedStartDate = "";
        if (item.ProjectName != null) this.editLocationTaskData.ProjectName = item.ProjectName;
        else this.editLocationTaskData.ProjectName = "";
        if (item.Status != null) this.editLocationTaskData.Status = item.Status;
        else this.editLocationTaskData.Status = "";
        if (item.StatusNo != null) this.editLocationTaskData.StatusId = item.StatusNo;
        else this.editLocationTaskData.StatusId = "";
        if (item.TaskId != null) this.editLocationTaskData.TaskId = item.TaskId;
        else this.editLocationTaskData.TaskId = "";
        if (item.TaskLocationId != null) this.editLocationTaskData.TaskLocationId = item.TaskLocationId;
        else this.editLocationTaskData.TaskLocationId = "";
        if (item.TaskTitle != null) this.editLocationTaskData.TaskTitle = item.TaskTitle;
        else this.editLocationTaskData.TaskTitle = "";
        if (item.VendorId != null) this.editLocationTaskData.VendorId = item.VendorId;
        else this.editLocationTaskData.VendorId = "";
        if (item.VendorName != null) this.editLocationTaskData.VendorName = item.VendorName;
        else this.editLocationTaskData.VendorName = "";

    }

    public CancelChangeDateLocationTask() {
        $('#changeDateLocationTask').modal('hide');
    }

    dateCompare(startDate: any, endDate: any): boolean {
        this.isValidFromTo = true;
        if (startDate != "" && startDate != null)
            startDate = moment(startDate, 'DD/MM/YYYY');

        if (endDate != "" && endDate != null)
            endDate = moment(endDate, 'DD/MM/YYYY');

        if ((endDate != "" && endDate != null) && (startDate != "" && startDate != null)) {
            if (endDate.isBefore(startDate))
                this.isValidFromTo = false;
        }
        return this.isValidFromTo;
    }

    SubmitChangeDateLocationTask(form: any) {
        this.isEditLocationDataFormSubmitted = true;
        if (this.dateCompare(this.editLocationTaskData.TLPlannedStartDate, this.editLocationTaskData.TLPlannedEndDate)) {
            if (form.form.valid) {
                this.UpdateLocationTask();
            }
        }
    }

    CloseLocationTask(item: any) {
        this.CloseLocationTaskFormLoad();
        this.filter.TaskId = item.TaskId;
        this.ImageUploadFile = "";
        this.InstallationReport = "";
        if (item.TaskId != null) this.editLocationTaskData.TaskId = item.TaskId;
        else this.editLocationTaskData.TaskId = "";
        if (item.Comment != null) this.editLocationTaskData.Comment = item.Comment;
        else this.editLocationTaskData.Comment = "";
        if (item.CompletedOn != null) this.editLocationTaskData.CompletedOn = item.CompletedOn;
        else this.editLocationTaskData.CompletedOn = "";
        if (item.CustomerContactPerson != null) this.editLocationTaskData.CustomerPersonName = item.CustomerContactPerson;
        else this.editLocationTaskData.CustomerPersonName = "";
        if (item.Fee != null) this.editLocationTaskData.Fee = item.Fee;
        else this.editLocationTaskData.Fee = 0;
        if (item.ImageUploadFile != null) this.editLocationTaskData.ImageUploadFile = item.ImageUploadFile;
        else this.editLocationTaskData.ImageUploadFile = "";
        if (item.InstallationRemark != null) this.editLocationTaskData.InstallationRemark = item.InstallationRemark;
        else this.editLocationTaskData.InstallationRemark = "";
        if (item.InstallationReport != null) this.editLocationTaskData.InstallationReport = item.InstallationReport;
        else this.editLocationTaskData.InstallationReport = "";
        if (item.Instruction != null) this.editLocationTaskData.Instruction = item.Instruction;
        else this.editLocationTaskData.Instruction = "";
        if (item.LocationCode != null) this.editLocationTaskData.LocationCode = item.LocationCode;
        else this.editLocationTaskData.LocationCode = "";
        if (item.LocationId != null) this.editLocationTaskData.LocationId = item.LocationId;
        else this.editLocationTaskData.LocationId = "";
        if (item.LocationName != null) this.editLocationTaskData.LocationName = item.LocationName;
        else this.editLocationTaskData.LocationName = "";
        if (item.TLPlannedEndDate != null) this.editLocationTaskData.TLPlannedEndDate = item.TLPlannedEndDate;
        else this.editLocationTaskData.TLPlannedEndDate = "";
        if (item.TLPlannedStartDate != null) this.editLocationTaskData.TLPlannedStartDate = item.TLPlannedStartDate;
        else this.editLocationTaskData.TLPlannedStartDate = "";
        if (item.ProjectName != null) this.editLocationTaskData.ProjectName = item.ProjectName;
        else this.editLocationTaskData.ProjectName = "";
        if (item.Status != null) this.editLocationTaskData.Status = item.Status;
        else this.editLocationTaskData.Status = "";
        this.editLocationTaskData.StatusId = 4;
        if (item.TaskId != null) this.editLocationTaskData.TaskId = item.TaskId;
        else this.editLocationTaskData.TaskId = "";
        if (item.TaskLocationId != null) this.editLocationTaskData.TaskLocationId = item.TaskLocationId;
        else this.editLocationTaskData.TaskLocationId = "";
        if (item.TaskTitle != null) this.editLocationTaskData.TaskTitle = item.TaskTitle;
        else this.editLocationTaskData.TaskTitle = "";
        if (item.VendorId != null) this.editLocationTaskData.VendorId = item.VendorId;
        else this.editLocationTaskData.VendorId = "";
        if (item.VendorName != null) this.editLocationTaskData.VendorName = item.VendorName;
        else this.editLocationTaskData.VendorName = "";

        if (item.TLPlannedStartDate != '' && item.TLPlannedStartDate != null) {
            let startDate = moment(item.TLPlannedStartDate, 'DD/MM/YYYY');
            console.log(startDate);
            $('.CompletedOndate').datetimepicker({
                format: 'DD/MM/YYYY',
                maxDate: moment().set({
                    hour: 0,
                    minute: 0,
                    second: 0,
                    millisecond: 0
                }),
                minDate: startDate
            });
        }

    }

    CloseLocationTaskFormLoad() {
        $('#resetCloseLocationTaskForm').trigger('click');
    }

    public ResetCloseLocationTaskForm(form: any) {
        // form.reset();
        // form.resetForm();
        this.isEditLocationDataFormSubmitted = false;
    }

    CancelCloseLocationTask() {
        $('#closeLocationTask').modal('hide');
    }

    SubmitCloseLocationTask(form: any) {
        this.isEditLocationDataFormSubmitted = true;
        if (form.form.valid) {
            this.UpdateLocationTask();
        }
    }


    public UpdateLocationTask() {

        let objItem: any = {};
        objItem.CompletedOn = this.editLocationTaskData.CompletedOn;
        objItem.CustomerPersonName = this.editLocationTaskData.CustomerPersonName;
        objItem.Fee = this.editLocationTaskData.Fee;
        objItem.ImageUploadFile = this.editLocationTaskData.ImageUploadFile;
        objItem.InstallationRemark = this.editLocationTaskData.InstallationRemark;
        objItem.InstallationReport = this.editLocationTaskData.InstallationReport;
        objItem.Instructions = this.editLocationTaskData.Instruction;
        objItem.LocationId = this.editLocationTaskData.LocationId;
        objItem.PlannedEndDate = this.editLocationTaskData.TLPlannedEndDate;
        objItem.PlannedStartDate = this.editLocationTaskData.TLPlannedStartDate;
        objItem.StatusId = this.editLocationTaskData.StatusId;
        objItem.TaskId = this.editLocationTaskData.TaskId;
        objItem.TaskLocationId = this.editLocationTaskData.TaskLocationId;
        objItem.VendorId = this.editLocationTaskData.VendorId;
        objItem.CreatedBy = this.userDetail.SiteUserId;
        console.log("UpdateLocationTask:");
        console.log(objItem);
        this.addEditLocationTaskData(objItem);
    }

    addEditLocationTaskData(TaskLocationModel) {
        this.showLoader = true;
        this._httpService.ajaxPost('LocationTask/AddUpdateTaskLocation', TaskLocationModel)
            .subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        msg[0] = msg[0].toLowerCase();
                        this._sharedService.ShowMessage(data["Status"].Message);
                    } else {
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                    if (msg[0] == "success") {
                        this.GetLocationTaskList();
                        $('#closeLocationTask').modal('hide');
                        $('#changeDateLocationTask').modal('hide');
                        this.filter.TaskId = 0;
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },

                () => {
                    this.showLoader = false;


                }
            );
    }



    fileEventInstallationReport(event, value) {
        this.showLoader = true;
        let TaskIdString: string = this.filter.TaskId.toString();
        console.log("TaskIdString: " + TaskIdString);
        let file: File = (event.target).files[0];
        this.fileList = (event.target).files;

        this._httpService.ajaxPostFile('LocationTask/AddUpdateFile', this.fileList).then((response) => {
                if (value == 1) {
                    if (response["FileName"] != null) {
                        this.editLocationTaskData.InstallationReport = response["FileName"];
                        this.InstallationReport = response["FileName"];
                    }
                } else {
                    if (response["FileName"] != null) {
                        this.editLocationTaskData.ImageUploadFile = response["FileName"];
                        this.ImageUploadFile = response["FileName"];
                    }
                }

                this.showLoader = false;

            }, (error) => {
                //FAILURE
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            }

        );
        this.showLoader = false;

    }


    openIRImage(item: any) {
        this.InstallationReport = item.InstallationReport; //JSON.parse(JSON.stringify(this.taskLocationList.filter((taskLocation) => taskLocation.TaskLocationId == item.TaskLocationId)[0].InstallationReport));
        var IRReport = this.documentRoute + this.InstallationReport;
        window.open(IRReport);
    }

    openImage(item: any) {
        this.ImageUploadFile = item.ImageUploadFile; //JSON.parse(JSON.stringify(this.taskLocationList.filter((taskLocation) => taskLocation.TaskLocationId == item.TaskLocationId)[0].ImageUploadFile));
        var ImageReport = this.documentRoute + this.ImageUploadFile;
        window.open(ImageReport);
    }

    ExportDataInExcel() {
        this.showLoader = true;

        this._httpService.ajaxPost('LocationTask/ExportStatusReport', {
            "TaskId": 0, //this.filter.TaskId,
            "TaskLocationId": 0,
            "VendorId": this.userDetail.VendorId
        }).subscribe(
            data => {
                this.reportFile = data["ReportFile"];
                window.location.href = this.reportFile;
            },
            err => {
                console.log("Export Status Report Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                this.showLoader = false;
            });
    }


    private dateSorterTLPlannedEndDate(item: any) {
        let start = moment("01/01/1970", "DD/MM/YYYY")
        let date = moment(item.TLPlannedEndDate, 'DD/MM/YYYY');

        if (item.TLPlannedEndDate == "" || !date.isValid())
            return 0;
        return date.diff(start);
    }

    private dateSorterCompletedOn(item: any) {
        let start = moment("01/01/1970", "DD/MM/YYYY")
        let date = moment(item.CompletedOn, 'DD/MM/YYYY');

        if (item.CompletedOn == "" || !date.isValid())
            return 0;
        return date.diff(start);
    }

    private dateSorterLogDate(item: any) {
        let start = moment("01/01/1970", "DD/MM/YYYY")
        let date = moment(item.LogDate, 'DD/MM/YYYY');

        if (item.LogDate == "" || !date.isValid())
            return 0;
        return date.diff(start);
    }


}


/** WEBPACK FOOTER **
 ** ./TypeScripts/VendorView/vendorview.component.ts
 **/